import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { BUTTON_CLASS_TYPES } from 'app/core/constants/app-button.constants';

@Component({
  selector: 'app-buttons',
  standalone: true,
  imports: [ButtonModule, TooltipModule, TranslatePipe],
  templateUrl: './app-buttons.html',
  styleUrls: ['./app-buttons.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppButtonsComponent {
  @Input() label?: string;
  @Input() btnClass: string | undefined = BUTTON_CLASS_TYPES.PRIMARY;

  @Input() btnBgColor?: string;
  @Input() btnTextColor?: string;

  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() disabled = false;

  @Input() icon?: string;
  @Input() iconPos: 'left' | 'right' = 'left';

  @Input() size: 'small' | 'normal' | 'large' = 'normal';
  @Input() loading = false;

  // Tooltip
  @Input() tooltip?: string;
  @Input() tooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';

  // Eventi
  @Output() click = new EventEmitter<Event>();
  @Output() focus = new EventEmitter<Event>();
  @Output() blur = new EventEmitter<Event>();

  onClick(event: Event) {
    event.stopPropagation();
    if (!this.disabled && !this.loading) {
      this.click.emit(event);
    }
  }

  get cssVars() {
    const vars: Record<string, string> = {};
    if (this.btnBgColor) vars['--btn-bg-color'] = this.btnBgColor;
    if (this.btnTextColor) vars['--btn-text-color'] = this.btnTextColor;
    return Object.keys(vars).length ? vars : undefined;
  }
}
